export const FROM_NOTIFICATION_KEY = 'from_notification';
export const VIEW_NOTIFICATION_COMMENTS_KEY = 'view_comments';
